import React, { useRef, useState } from 'react'
import Api from '@/_helpers/Api'
import { trans } from '@/_providers/Translation'
import { ENDPOINTS, signatureUrl } from './config'

//images
import uploadImage from '@/assets/img/storage/icons/upload.svg'
import loader from '@/assets/img/loader.svg'

// Подписът на управителя. Качва се веднъж и бекендът го поставя върху всеки
// генериран договор - затова се само заменя, но никога не се маха.
function Signature(props) {

    const image = props.image || ''

    const inputRef = useRef(null)

    const [state, setState] = useState({
        loading: false,
        preview: '',
    })

    const handleOpen = e => {
        e.preventDefault()

        inputRef.current && inputRef.current.click()
    }

    const handleAttach = e => {
        const file = e.target.files[0]

        if (!file) {
            return
        }

        const preview = URL.createObjectURL(file)

        setState({
            loading: true,
            preview: preview,
        })

        let data = new FormData()

        data.append('file', file)

        let url = image ? ENDPOINTS.defaultSignatureUpdate : ENDPOINTS.defaultSignatureAdd

        Api.post(url, data)
            .then(res => {
                props.onSaved(signatureUrl(res.data) || preview)
            }).catch(() => {
                setState(prev => ({
                    ...prev,
                    preview: ''
                }))
            }).finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))

                // позволява повторно качване на същия файл
                e.target.value = ''
            })
    }

    const shown = state.preview || image

    return (
        <div className="upload-signature">
            {shown
                ?
                <img src={shown} className="uploaded-image" alt="signature" />
                :
                <div className="initial-look">
                    <img src={uploadImage} alt="upload" />
                    <b>
                        {trans('buttons.attachSignature')}
                    </b>
                    <p>
                        {trans('labels.allowedImageFormats')}
                    </p>
                </div>
            }

            <div className="actions">
                <input
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleAttach}
                    hidden
                />

                {state.loading
                    ?
                    <img src={loader} alt="loading" height="35" />
                    :
                    <button className="button-add button-small" onClick={handleOpen}>
                        {image ? trans('buttons.attachNewSignature') : trans('buttons.attachSignature')}
                    </button>
                }
            </div>
        </div>
    )
}

export default Signature
